/**
 * 船位图底图降级链：
 * 1. 飞驼 map.freightower.com（lyrs=m）
 * 2. 船达通 maps*.shipdt.com（lyrs=m）—— Referer 为测试域时会被 403，必须 no-referrer 或同源反代
 * 3. 卫星（飞驼 lyrs=s → 船达通 lyrs=s）
 * 4. 海图 OpenSeaMap（手动）
 *
 * 关键根因（实测）：
 * maps.shipdt.com 对 Referer=http://47.107.79.132/、erp.huoping.net 返回 403，
 * 对 localhost / 无 Referer 返回 200 —— 故开发正常、测试只能落到卫星。
 */

const BASE = (typeof process !== 'undefined' && process.env && process.env.BASE_URL) || '/'

export function pageProtocol() {
  if (typeof window !== 'undefined' && window.location && window.location.protocol) {
    return window.location.protocol === 'https:' ? 'https' : 'http'
  }
  return 'http'
}

/** 飞驼普通地图 */
export function freightowerMapUrl() {
  return `${pageProtocol()}://map.freightower.com/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}&hl=zh-CN`
}

/** 飞驼卫星 */
export function freightowerSatUrl() {
  return `${pageProtocol()}://map.freightower.com/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}&hl=zh-CN`
}

/**
 * 船达通普通地图。
 * 优先直连（配合 TileLayer no-referrer）；若配置了同源反代可用 VUE_APP_SHIPDT_VIA_PROXY=1。
 */
export function shipdtMapUrl() {
  if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_SHIPDT_VIA_PROXY === '1') {
    return `${BASE}mapvt/vt/lyrs=m&hl=zh-CN&gl=cn&s=Gal&z={z}&x={x}&y={y}`
  }
  // 固定 maps0，避免多子域个别 403；子域轮询对 Referer 场景无帮助
  return `${pageProtocol()}://maps0.shipdt.com/vt/lyrs=m&hl=zh-CN&gl=cn&s=Gal&z={z}&x={x}&y={y}`
}

export function shipdtSatUrl() {
  if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_SHIPDT_VIA_PROXY === '1') {
    return `${BASE}mapvt/vt/lyrs=s&hl=zh-CN&gl=cn&s=Gal&z={z}&x={x}&y={y}`
  }
  return `${pageProtocol()}://maps0.shipdt.com/vt/lyrs=s&hl=zh-CN&gl=cn&s=Gal&z={z}&x={x}&y={y}`
}

/** @deprecated 直连不再用 {s} 子域 */
export const SHIPDT_MAP_SUBDOMAINS = ['0', '1', '2', '3']

export function openSeaBaseUrl() {
  return `${pageProtocol()}://t2.openseamap.org/tile/{z}/{x}/{y}.png`
}

export function openSeaMarkUrl() {
  return `${pageProtocol()}://tiles.openseamap.org/seamark/{z}/{x}/{y}.png`
}

export const OPEN_SEA_BASE = 'https://t2.openseamap.org/tile/{z}/{x}/{y}.png'
export const OPEN_SEA_MARK = 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png'

export function chartTileBase() {
  if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_CHART_BASE) {
    return process.env.VUE_APP_CHART_BASE
  }
  return `${BASE}emap/`
}

function hexPad(n) {
  let t = Number(n).toString(16)
  while (t.length < 8) t = `0${t}`
  return t
}

/**
 * 不带 Referer 的瓦片层：绕过船达通按业务域名 Referer 的 403。
 */
export function registerNoReferrerTileLayer(L) {
  if (!L || L.TileLayer.NoReferrer) return
  L.TileLayer.NoReferrer = L.TileLayer.extend({
    createTile(coords, done) {
      const tile = L.TileLayer.prototype.createTile.call(this, coords, done)
      if (tile) {
        try {
          tile.referrerPolicy = 'no-referrer'
          if (tile.setAttribute) tile.setAttribute('referrerpolicy', 'no-referrer')
        } catch (e) { /* ignore */ }
      }
      return tile
    }
  })
  L.tileLayer.noReferrer = function (url, options) {
    return new L.TileLayer.NoReferrer(url, options)
  }
}

export function registerChartLayer(L) {
  if (!L || L.TileLayer.ChartLayer) return

  L.TileLayer.ChartLayer = L.TileLayer.extend({
    initialize(baseUrl, options) {
      const root = baseUrl || chartTileBase()
      const url = root.replace(/\/?$/, '/') + '{s}/{x}.png'
      L.TileLayer.prototype.initialize.call(this, url, options)
    },
    createTile(coords, done) {
      const tile = L.TileLayer.prototype.createTile.call(this, coords, done)
      if (tile) {
        try {
          tile.referrerPolicy = 'no-referrer'
          if (tile.setAttribute) tile.setAttribute('referrerpolicy', 'no-referrer')
        } catch (e) { /* ignore */ }
      }
      return tile
    },
    getTileUrl(coords) {
      const z = coords.z
      const lev = z < 2 ? `LN${z}` : (z < 12 ? `L0${z - 2}` : `L${z - 2}`)
      const row = `R${hexPad(coords.y)}`
      const col = `C${hexPad(coords.x)}`
      return L.Util.template(this._url, {
        s: `${lev}/${row}`,
        x: col
      })
    }
  })

  L.tileLayer.chartLayer = function (baseUrl, options) {
    return new L.TileLayer.ChartLayer(baseUrl, options)
  }
}
